/* Landing primerpaso — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'primerpaso'). */

window.LP={"bundles": null, "price": 144900, "compare": 230000, "slug": "primerpaso", "accent": "#C2551F", "accentSoft": "#FBEFE7", "variants": [{"key": "color", "label": "Color", "per_unit": true, "required": false, "sv": {"Roja": "Roja", "Azul": "Azul", "Blanca": "Blanca", "Negra": "Negra"}, "items": ["Roja", "Azul", "Blanca", "Negra"], "imgs": {"Roja": "prod/b-roja.jpg", "Azul": "prod/b-azul.jpg", "Blanca": "prod/b-blanca.jpg", "Negra": "prod/b-negra.jpg"}}], "default_bundle": null, "product": "Bicicleta de equilibrio sin pedales", "unit": "bici", "units": "bicis", "wa": "573007290464", "thumb": "prod/b-roja.jpg", "sizes": null, "bundles_by": null, "gifts": [{"title": "Aprende a montar en 4 semanas", "min": 1, "cover": "regalos/aprende-a-montar.jpg"}]};
// contrato del publicador del tema (shopify-landings): __primerpaso_SEL · primerpasoTriggerCOD · te_regalo
window.LP.setSel=function(s){window.__primerpaso_SEL=s};
window.LP.trigger=function(){if(typeof window.primerpasoTriggerCOD!=='function')return false;window.primerpasoTriggerCOD();return true};
(function () {
  var LP = window.LP;
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var fmt = function (v) { return '$' + String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  // en Shopify las imágenes viven en el CDN del tema: __A (lo inyecta el publicador) traduce la ruta local
  var A = function (p) { return p && window.__A ? window.__A(p) : p; };
  var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var cap = function (t) { return t.charAt(0).toUpperCase() + t.slice(1); };

  var st = { bundle: null, sel: {}, rows: [] };
  LP.variants.forEach(function (g) { st.sel[g.key] = g.default === undefined ? g.items[0] : g.default; });
  if (LP.bundles) st.bundle = LP.default_bundle || LP.bundles[0].id;

  // pedido → envío → entrega: días hábiles de Colombia (sin sábados, domingos ni festivos)
  var FESTIVOS = ['2026-11-02', '2026-11-16', '2026-12-08', '2026-12-25', '2027-01-01', '2027-01-11', '2027-03-22', '2027-03-25', '2027-03-26'];
  var habil = function (d) { var k = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); return d.getDay() !== 0 && d.getDay() !== 6 && FESTIVOS.indexOf(k) < 0; };
  var masHabiles = function (n) { var d = new Date(), k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (habil(d)) k++; } return d; };
  var dia = function (d) { return ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'][d.getDay()] + ', ' + d.getDate() + ' ' + ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'][d.getMonth()]; };
  var rango = function (a, b) { return a === b ? dia(masHabiles(a)) : dia(masHabiles(a)) + ' - ' + dia(masHabiles(b)); };
  $$('.eta').forEach(function (el) {
    var r = el.dataset.eta.split(',').map(Number), envio = Math.max(1, r[0] - 1);
    var t = [dia(new Date()), rango(1, envio), rango(r[0], r[1])];
    $$('[data-d]', el).forEach(function (b) { b.textContent = t[+b.dataset.d]; });
  });

  function bundle() { return (LP.bundles || []).filter(function (b) { return b.id === st.bundle; })[0] || null; }
  function bv(b) { return b && b.by ? b.by[st.sel[LP.bundles_by]] : b; }
  function units() { var b = bundle(); return b ? b.units : 1; }
  function price() {
    var b = bundle();
    if (b) return bv(b).price;
    if (LP.sizes) return LP.sizes[st.sel.size] || LP.price;
    return LP.price;
  }
  function compare() { var b = bundle(); return b ? bv(b).compare : LP.compare; }
  function gifts() { var n = units(); return (LP.gifts || []).filter(function (g) { return g.min <= n; }); }
  function perUnit() { return LP.variants.filter(function (g) { return g.per_unit && g.items.length > 1; }); }

  function syncRows() {
    var n = units();
    while (st.rows.length < n) st.rows.push({});
    st.rows.length = n;
    st.rows.forEach(function (r) { LP.variants.forEach(function (g) { if (!g.per_unit || !r[g.key]) r[g.key] = st.sel[g.key]; }); });
  }

  // ---- mezcla por unidad (igual que ESCUDO): una fila por unidad con la foto de cada color; tallas en pastillas ----
  function renderMix() {
    var box = $('#mix'), per = perUnit();
    if (!box) return;
    var show = units() > 1 && per.length > 0;
    box.hidden = !show;
    if (!show) return;
    $('#mixRows').innerHTML = st.rows.map(function (r, i) {
      return '<div class="mix-row" data-i="' + i + '"><span class="mix-n">' + cap(LP.unit) + ' ' + (i + 1) + '<small>' +
        per.map(function (g) { return esc(r[g.key] || ('elige ' + g.label.toLowerCase())); }).join(' · ') + '</small></span>' +
        per.map(function (g) {
          var hasImg = Object.keys(g.imgs || {}).length > 0;
          return '<div class="mix-opts' + (hasImg ? '' : ' txt') + '">' + g.items.map(function (v) {
            var on = r[g.key] === v ? ' class="on"' : '';
            return '<button type="button" data-g="' + g.key + '" data-v="' + esc(v) + '"' + on + ' aria-label="' + esc(cap(LP.unit) + ' ' + (i + 1) + ': ' + v) + '">' +
              (hasImg && g.imgs[v] ? '<img src="' + esc(A(g.imgs[v])) + '" alt="">' : esc(v)) + '</button>';
          }).join('') + '</div>';
        }).join('') + '</div>';
    }).join('');
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'bundle' || t.name === 'bundle2') { st.bundle = t.value; syncRows(); render(); }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#mixRows button[data-g]');
    if (!b) return;
    var i = +b.closest('.mix-row').dataset.i;
    st.rows[i][b.dataset.g] = b.dataset.v;
    if (i === 0) st.sel[b.dataset.g] = b.dataset.v;
    render();
  });

  function render() {
    var p = price(), c = compare();
    $$('[data-bind=price]').forEach(function (el) { el.textContent = fmt(p); });
    $$('[data-bind=compare]').forEach(function (el) { el.textContent = c && c > p ? fmt(c) : ''; });
    $$('[data-bind=save]').forEach(function (el) { el.textContent = c && c > p ? 'Ahorras ' + fmt(c - p) : ''; });
    $$('.b input').forEach(function (i) { i.checked = i.value === st.bundle; i.closest('.b').classList.toggle('on', i.checked); });
    if (LP.bundles_by) $$('.b').forEach(function (el) {
      var d = (LP.bundles || []).filter(function (x) { return x.id === $('input', el).value; })[0]; if (!d) return;
      var v = bv(d);
      $('.b-p b', el).textContent = fmt(v.price);
      var s = $('.b-p s', el); if (s) s.textContent = v.compare ? fmt(v.compare) : '';
      $('.b-s', el).textContent = v.sub || '';
      var sv = $('.b-save', el); if (sv) sv.textContent = v.compare ? 'Ahorras ' + fmt(v.compare - v.price) : '';
    });
    var n = units();
    $$('.gb-i').forEach(function (el) { el.classList.toggle('off', +el.dataset.min > n); });
    $$('.sw,.pill').forEach(function (b) { b.classList.toggle('on', st.sel[b.dataset.g] === b.dataset.v); });
    $$('[data-cur]').forEach(function (el) { el.textContent = st.sel[el.dataset.cur] || 'elige'; });
    var img = null;
    LP.variants.forEach(function (g) { if (!img && g.imgs[st.sel[g.key]]) img = g.imgs[st.sel[g.key]]; });
    var si = $('#stImg'); if (si) si.src = A(img || LP.thumb);
    renderMix();
    var lab = $('#stLab');
    if (lab) { var b0 = bundle(), per = perUnit(), u = [];
      st.rows.forEach(function (r) { var k = per.map(function (g) { return r[g.key]; }).filter(Boolean).join(' '); if (k && u.indexOf(k) < 0) u.push(k); });
      lab.textContent = [b0 ? b0.title.replace(/^Compra \d+, lleva /, 'Lleva ') : '', u.length > 2 ? u.length + ' colores' : u.join(' + ')].filter(Boolean).join(' · '); }
  }

  // ---- galería ----
  var gm = $('#gMain');
  if (gm) {
    var n = gm.children.length;
    var dots = document.createElement('div'); dots.className = 'g-dots';
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
    if (n > 1) gm.parentNode.appendChild(dots);
    var mark = function () {
      var k = Math.round(gm.scrollLeft / gm.clientWidth);
      $$('.g-th').forEach(function (t, j) { t.classList.toggle('on', j === k); });
      $$('i', dots).forEach(function (d, j) { d.classList.toggle('on', j === k); });
    };
    gm.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    $$('.g-th').forEach(function (t) { t.addEventListener('click', function () { gm.scrollTo({ left: gm.clientWidth * (+t.dataset.i), behavior: 'smooth' }); }); });
    mark();
  }
  function showImg(src) {
    if (!gm || !src) return;
    var want = A(src), k = $$('.g-slide img', gm).map(function (i) { return i.getAttribute('src'); }).indexOf(want);
    if (k >= 0) gm.scrollTo({ left: gm.clientWidth * k, behavior: 'smooth' });
  }

  $$('.sw,.pill').forEach(function (b) {
    b.addEventListener('click', function () {
      st.sel[b.dataset.g] = b.dataset.v;
      st.rows.forEach(function (r) { r[b.dataset.g] = b.dataset.v; });   // el selector principal pone todas las unidades iguales
      if (b.dataset.img) showImg(b.dataset.img);
      render();
    });
  });
  $$('.size').forEach(function (b) {
    b.addEventListener('click', function () { st.sel.size = b.dataset.size; st.rows.forEach(function (r) { r.size = b.dataset.size; }); render(); window.openOrder(); });
  });

  // testimonio rotativo
  var tcs = $$('.tc'), tdots = $$('.tcard .dots i'), tk = 0;
  if (tcs.length > 1) setInterval(function () {
    tcs[tk].classList.remove('on'); tdots[tk].classList.remove('on');
    tk = (tk + 1) % tcs.length;
    tcs[tk].classList.add('on'); tdots[tk].classList.add('on');
  }, 5000);

  window.moreReviews = function () { $$('.rv.is-hidden').forEach(function (r) { r.classList.remove('is-hidden'); }); var b = $('#rvMore'); if (b) b.remove(); };

  // ---- aviso flotante ----
  function toast(msg, ms) {
    var t = document.getElementById('lp-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'lp-toast';
      t.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);z-index:2147483000;background:#1B1A17;color:#fff;font:700 15px/1.25 Manrope,system-ui,sans-serif;padding:13px 20px;border-radius:999px;box-shadow:0 6px 24px rgba(0,0,0,.25);transition:opacity .3s;pointer-events:none;max-width:92vw;text-align:center';
      document.body.appendChild(t);
    }
    t.textContent = msg; t.style.opacity = msg ? '1' : '0';
    clearTimeout(t._h); if (msg && ms) t._h = setTimeout(function () { t.style.opacity = '0'; }, ms);
  }

  // ---- pedido ----
  function needPick() {
    var g = LP.variants.filter(function (x) { return x.required && (!st.sel[x.key] || st.rows.some(function (r) { return !r[x.key]; })); })[0];
    if (!g) return false;
    var el = $('.vg[data-g="' + g.key + '"]') || $('#mix');
    if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    toast('Elige ' + g.label.toLowerCase() + ' para continuar', 2600);
    return true;
  }
  function wantedLines() {   // [{tokens:[...], qty}] una por combinación distinta
    var out = [], idx = {};
    st.rows.forEach(function (r) {
      var toks = LP.variants.map(function (g) { return (g.sv && g.sv[r[g.key]]) || r[g.key]; }).filter(Boolean), k = toks.join('|');
      if (k in idx) out[idx[k]].qty++; else { idx[k] = out.length; out.push({ tokens: toks, qty: 1 }); }
    });
    return out;
  }
  window.openOrder = function () {
    syncRows();
    if (needPick()) return;
    var gs = gifts();
    try { localStorage.setItem('te_regalo', LP.slug + (gs.length && gs.length < (LP.gifts || []).length ? '-1' : '') + '|' + Date.now()); } catch (e) {}
    if (window.Shopify && /\/products\//.test(location.pathname)) { shopOrder(); return; }
    previewOrder();
  };

  // Shopify: la variante real de cada unidad × su cantidad → Releasit
  var norm = function (t) { return ' ' + String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim() + ' '; };
  function findVar(prod, tokens) {
    var ok = (prod.variants || []).filter(function (v) {
      var t = norm([v.title, v.option1, v.option2, v.option3].join(' '));
      return tokens.every(function (x) { return t.indexOf(norm(x)) >= 0; });
    });
    return ok.filter(function (v) { return v.available; })[0] || ok[0] || null;
  }
  var espera = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  async function listoReleasit() {
    for (var i = 0; i < 80; i++) {
      try { var R = window._rsiV2, s = R && R.getState && R.getState(); if (R && R.cartService && s && s.loadingState && !s.loadingState.isLoading) return R; } catch (e) {}
      await espera(100);
    }
    throw new Error('Releasit no cargó');
  }
  async function shopOrder() {
    toast('Preparando tu pedido…');
    var lines = [];
    try {
      var V = window[LP.slug.toUpperCase() + '_VARIANTS'], prod = null;
      if (V && V.length) prod = { variants: V.map(function (x) { return { id: x.id, title: [x.color, x.talla].filter(Boolean).join(' / '), option1: x.color, option2: x.talla, available: x.available }; }) };
      else prod = await fetch(location.pathname.replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      var first = null;
      wantedLines().forEach(function (w) {
        var v = LP.variants.length ? findVar(prod, w.tokens) : ((prod.variants || []).filter(function (x) { return x.available; })[0] || prod.variants[0]);
        if (!v) throw new Error('variante no encontrada: ' + w.tokens.join(' / '));
        if (!first) first = v;
        lines.push({ merchandiseId: 'gid://shopify/ProductVariant/' + v.id, quantity: w.qty });
      });
      LP.setSel({ qty: units(), color: first.option1, size: first.option2 || null, lineas: lines });
      brandForm();
      await rsiCOD(lines);   // una línea por variante (igual que ESCUDO y El Comedor del 24)
      toast('');
    } catch (e) {
      console.warn('[' + LP.slug + '] pedido:', e);
      toast('');
      if (lines.length === 1 && LP.trigger()) return;   // una sola variante: respaldo de la fábrica (botón nativo de Releasit)
      toast('No pudimos preparar tu pedido. Revisa tu conexión e inténtalo de nuevo.', 4500);
    }
  }
  // varias variantes en un pedido: carrito interno de Releasit (flujo probado en El Comedor del 24)
  async function rsiCOD(lines) {
    var R = await listoReleasit(), cs = R.cartService;
    R.setState({ isOpen: false });
    var s = R.getState(), S = window._RSI_COD_FORM_SETTINGS;
    if (S && S.productPage) S.productPage.addMode = 'product-plus-cart';
    R.setState({ productPage: Object.assign({}, s.productPage, { addMode: 'product-plus-cart' }) });
    var id = s.cartInfo && s.cartInfo.id;
    if (!id) { var g0 = await cs.getCart(); id = g0.data.cart.id; R.setState({ cartInfo: g0.data.cart }); }
    await cs.clearCart(id);
    await cs.addProduct(id, lines);
    R.setState({ isOpen: true });
    R.setState({ triggerCartUpdate: 1 });
    var want = {}; lines.forEach(function (l) { want[l.merchandiseId] = l.quantity; });
    for (var k = 0, ok = false; k < 4 && !ok; k++) {   // verificar y autocorregir: el carrito debe quedar con EXACTAMENTE estas líneas
      await espera(k ? 700 : 1200);
      var cid = R.getState().cartInfo.id, g = await cs.getCart(cid), edges = g.data.cart.lines.edges || [];
      var sobran = [], corregir = [], vistos = {};
      edges.forEach(function (e) {
        var m = e.node.merchandise.id;
        if (!(m in want) || vistos[m]) sobran.push(e.node.id);
        else { vistos[m] = 1; if (e.node.quantity !== want[m]) corregir.push({ id: e.node.id, quantity: want[m] }); }
      });
      var faltan = lines.filter(function (l) { return !vistos[l.merchandiseId]; });
      ok = !sobran.length && !corregir.length && !faltan.length;
      if (!ok) {
        if (sobran.length) await cs.removeProduct(cid, sobran);
        if (corregir.length) await cs.updateProduct(cid, corregir);
        if (faltan.length) await cs.addProduct(cid, faltan);
        R.setState({ triggerCartUpdate: 1 });
      }
    }
    if (!ok) { R.setState({ isOpen: false }); throw new Error('el carrito de Releasit no cuadró'); }
  }

  // formulario de Releasit con la marca de la página + las guías de regalo adentro
  var formObs = null, formEl = null;
  function brandForm() {
    if (!document.getElementById('lp-rsi-css')) {
      var c = document.createElement('style'); c.id = 'lp-rsi-css';
      c.textContent = '#rsi_form_wrapper .rsi-submit_button{background:#1B1A17!important;border:0!important;border-radius:12px!important;box-shadow:0 10px 24px rgba(27,26,23,.25)!important;color:#fff!important}' +
        '#rsi_form_wrapper .rsi-submit_button .rsi-custom-button-content{font-family:Manrope,system-ui,sans-serif!important;font-size:16px!important;font-weight:800!important;line-height:1.25!important;color:#fff!important}' +
        '#rsi_form_wrapper .rsi-submit_button .rsi-icon{color:#fff!important}' +
        '#rsi_form_wrapper .rsi-form-header,#rsi_form_wrapper .rsi-form-header *,#rsi_form_wrapper .rsi-form-close-button{color:#1B1A17!important}' +
        '#rsi_form_wrapper .rsi-shipping-rates-item{border-color:#1B1A17!important}' +
        'body:has(#rsi_form_wrapper[open]) #sticky,body:has(#rsi_form_wrapper[open]) #lpAnn{visibility:hidden!important}' +
        '#lp-rsi-regalos{margin:10px 0 4px;padding:10px 12px;border:1.5px dashed ' + LP.accent + ';border-radius:10px;background:' + LP.accentSoft + ';color:#1B1A17;line-height:1.3;font-family:Manrope,system-ui,sans-serif}' +
        '#lp-rsi-regalos .t{font-weight:800;font-size:14px;color:' + LP.accent + ';margin:0 0 6px}' +
        '#lp-rsi-regalos .r{display:flex;align-items:center;gap:8px;font-size:13px;margin:5px 0}' +
        '#lp-rsi-regalos img{width:26px;height:36px;border-radius:3px;object-fit:cover;flex:0 0 auto;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.2)}' +
        '#lp-rsi-regalos .r span{flex:1}#lp-rsi-regalos b{color:#2F7D4F;font-size:12px;font-weight:800;letter-spacing:.04em}' +
        '#lp-rsi-regalos .n{font-size:11.5px;color:#6E6A63;margin:6px 0 0}';
      document.head.appendChild(c);
    }
    var t0 = Date.now();
    (function busca() {
      var f = document.getElementById('rsi_form_wrapper');
      if (f && f !== formEl) {
        if (formObs) formObs.disconnect(); formEl = f; var pend = 0;
        formObs = new MutationObserver(function () { if (!pend) { pend = 1; setTimeout(function () { pend = 0; regalosForm(); }, 30); } });
        formObs.observe(f, { childList: true, subtree: true });
      }
      regalosForm();
      if (!f && Date.now() - t0 < 6000) setTimeout(busca, 150);
    })();
  }
  function regalosForm() {
    var gs = gifts(), box = document.getElementById('lp-rsi-regalos'), anc = document.querySelector('#rsi_form_wrapper .rsi-product-details-wrapper');
    if (!gs.length || !anc) { if (box && !anc) box.remove(); return; }
    var key = gs.map(function (g) { return g.title; }).join('|');
    if (!box) { box = document.createElement('div'); box.id = 'lp-rsi-regalos'; }
    if (box.getAttribute('data-k') !== key) {
      box.setAttribute('data-k', key);
      box.innerHTML = '<p class="t">Con tu pedido te llevas gratis</p>' + gs.map(function (g) {
        return '<div class="r"><img src="' + esc(A(g.cover)) + '" alt=""><span>' + esc(g.title) + ' (PDF)</span><b>GRATIS</b></div>';
      }).join('') + '<p class="n">Las guías se descargan apenas confirmes tu pedido.</p>';
    }
    if (box.parentNode !== anc.parentNode || box.previousElementSibling !== anc) anc.parentNode.insertBefore(box, anc.nextSibling);
  }

  // fuera de Shopify (vista previa): resumen del pedido; en la tienda este botón abre Releasit
  function previewOrder() {
    var b = bundle(), per = perUnit(), h = '';
    h += '<div class="o-line"><b>' + esc(LP.product) + '</b>' + (b ? '<span>' + esc(b.title) + (b.title.indexOf(LP.units) < 0 ? ' · ' + b.units + ' ' + LP.units : '') + '</span>' : '') + '</div>';
    LP.variants.filter(function (g) { return !g.per_unit; }).forEach(function (g) { h += '<div class="o-line"><span>' + esc(g.label) + '</span><b>' + esc(st.sel[g.key]) + '</b></div>'; });
    if (per.length) st.rows.forEach(function (r, i) {
      h += '<div class="o-line"><span>' + (st.rows.length > 1 ? cap(LP.unit) + ' ' + (i + 1) : cap(LP.unit)) + '</span><b>' + per.map(function (g) { return esc(r[g.key]); }).join(' · ') + '</b></div>';
    });
    gifts().forEach(function (g) { h += '<div class="o-line gift"><span>Regalo</span><b>' + esc(g.title) + ' (PDF)</b></div>'; });
    $('#oRows').innerHTML = h;
    $('#oTotal').textContent = fmt(price());
    $('#order').classList.add('open'); $('#order').setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }
  window.closeOrder = function () {
    $('#order').classList.remove('open'); $('#order').setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  };
  $('#order').addEventListener('click', function (e) { if (e.target.id === 'order') window.closeOrder(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.closeOrder(); });

  syncRows(); render();
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__primerpaso_SEL || {};
    var V = window.PRIMERPASO_VARIANTS || [];
    var n = function (x) { return String(x || '').toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); };
    var v = V.filter(function (x) {
      return n(x.color) === n(s.color) && (s.size == null || String(x.talla) === String(s.size));
    })[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__primerpaso-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.primerpasoTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
